import { Tab, Tabs } from '@mui/material';
import { OrdersTabsProps } from './OrdersTabs.types';

export function OrdersTabs({ selectedTab, onChange, canGenerateOrders }: OrdersTabsProps) {
  const styles = {
    '& .MuiTab-root': { color: '#666', fontSize: '0.875rem' },
    '& .MuiTab-root.Mui-selected': { color: 'rgb(132, 189, 0)' },
    '& .MuiTabs-indicator': { backgroundColor: 'rgb(132, 189, 0)' }
  };

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    onChange(newValue);
  };

  return (
    <div className="orders-tabs-bar">
      <Tabs value={selectedTab} onChange={handleChange} sx={styles}>
        <Tab label="Розпорядження" />
        {canGenerateOrders && <Tab label="Історія змін порядкового номеру" />}
      </Tabs>
    </div>
  );
}
